module.exports = __webpack_public_path__ + "img/icon_shield.da3d25dd.png";